<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import WorkForm from './WorkForm.vue'
import type { VueComponentProps } from '@/src/types/vueUtil'

export type WorkFormProps = VueComponentProps<typeof WorkForm>

const props = defineProps<{
  workFormProps: WorkFormProps
  modelValue: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const localModelValue = useVModel(props, 'modelValue', emit, { passive: true, eventName: 'update:modelValue' })

const handleClose = () => {
  localModelValue.value = false
}
</script>

<template>
  <Teleport to="body">
    <BModal v-model="localModelValue" class="work-form-modal" @close="handleClose">
      <WorkForm v-bind="workFormProps" @close="handleClose" />
    </BModal>
  </Teleport>
</template>

<style scoped lang="scss">
@use '@/stylesheets/application/resources';

.work-form-modal {
  :deep(.modal-content) {
    // NOTE: スマホの表示崩れ対策
    max-height: none;

    // NOTE: buefyがデフォルトでwidth: 640px指定している関係でモーダル横をクリックしても閉じない対策
    @include resources.tablet {
      width: auto;
    }
  }
}
</style>
